/** Frontend routes for canonical entity IDs ({type}:{id}). */

import { parseEntityId } from './entityIds';

export { formatEntityId, parseEntityId } from './entityIds';

export function entityFrontendPath(
  entityId: string,
  projectId: string,
): string | undefined {
  const parsed = parseEntityId(entityId);
  if (!parsed) return undefined;
  const { type, id } = parsed;

  switch (type) {
    case 'project':
      return `/projects/${id}`;
    case 'repository':
      return `/projects/${projectId}/phase-0/artifacts`;
    case 'incident':
      return `/projects/${projectId}/operate/incident?incident=${encodeURIComponent(id)}`;
    case 'investigation':
      return `/projects/${projectId}/operate/incident?incident=${encodeURIComponent(id)}`;
    case 'change_request':
      return `/projects/${projectId}/operate/engineering?cr=${encodeURIComponent(id)}`;
    case 'engineering_episode':
      return `/projects/${projectId}/operate/learning`;
    case 'service':
    case 'workflow':
    case 'flow':
    case 'component':
    case 'knowledge_node':
    case 'api':
    case 'datastore':
      return `/projects/${projectId}/phase-1/graph/explorer?node=${encodeURIComponent(id)}`;
    case 'source_file':
    case 'config_file':
      return `/projects/${projectId}/phase-0/artifacts?file=${encodeURIComponent(id)}`;
    case 'document':
      return `/projects/${projectId}/phase-0/artifacts`;
    case 'worker':
      return `/projects/${projectId}/phase-1/graph/explorer?worker=${encodeURIComponent(id)}`;
    case 'worker_insight':
      return `/projects/${projectId}/phase-1/insights`;
    case 'environment':
      return `/projects/${projectId}/operate/test-environment`;
    default:
      return undefined;
  }
}
